import { render, staticRenderFns } from "./standByLedger.vue?vue&type=template&id=dd6fa966&scoped=true"
import script from "./standByLedger.vue?vue&type=script&lang=js"
export * from "./standByLedger.vue?vue&type=script&lang=js"
import style0 from "./standByLedger.vue?vue&type=style&index=0&id=dd6fa966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6fa966",
  null
  
)

export default component.exports